import { useRevalidator } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { identityFetch } from '../../clientAPI/identity';
import { QUERY_KEYS } from '../../constants';
import { sortBy, prop, toLower, compose } from 'ramda';

const sortByName = sortBy(compose(toLower, prop('name')));

export function useRoleList() {
  const revalidator = useRevalidator();
  const queryRef = useQuery([QUERY_KEYS.ROLE_LIST], identityFetch(), {
    staleTime: Infinity,
    suspense: true,
    onError: (err: { status: number }) =>
      err.status === 401 && revalidator.revalidate(),
  });
  if (queryRef.data?.roles) {
    const roles = sortByName(queryRef.data.roles);
    return { ...queryRef, data: { ...queryRef.data, roles } };
  }
  return queryRef;
}
